"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }

/* Rev 26 O2: an unsaved message, kept per campaign and user in this browser
 * (not on the server, so an unfinished campaign doesn't look finished and a
 * running one doesn't change before Save). Storage can be unavailable or
 * full; then the draft just isn't kept. */
const keyOf = (userKey, campaignKey) =>
  `broadcast-message-draft:${_nullishCoalesce(userKey, () => ( 'anonymous'))}:${campaignKey}`

/* Review R800-29: the draft keeps the saved message it was started from, so
 * a message saved since (another tab or user) isn't overwritten unseen. */





const isDraft = (v) =>
  typeof v === 'object' && v !== null
  && typeof (v ).template === 'string'
  && typeof (v ).savedTemplate === 'string'

/* Review R800-32: drafts were never released, so one in another format
 * (Rev 26 stored plain text) isn't migrated: it reads as no draft, and the
 * step removes it. */
 const loadMessageDraft = (userKey, campaignKey) => {
  try {
    const stored = JSON.parse(_nullishCoalesce(window.localStorage.getItem(keyOf(userKey, campaignKey)), () => ( 'null')))
    return isDraft(stored) ? stored : null
  } catch (e) {
    return null
  }
}; exports.loadMessageDraft = loadMessageDraft

 const saveMessageDraft = (userKey, campaignKey, draft) => {
  try {
    window.localStorage.setItem(keyOf(userKey, campaignKey), JSON.stringify(draft))
  } catch (e2) {
    // Not kept.
  }
}; exports.saveMessageDraft = saveMessageDraft

 const clearMessageDraft = (userKey, campaignKey) => {
  try {
    window.localStorage.removeItem(keyOf(userKey, campaignKey))
  } catch (e3) {
    // Nothing to clear.
  }
}; exports.clearMessageDraft = clearMessageDraft
